<template>
  <div class="imageGalleryViewMain" :style="cssProps">
    <div class="topBar">
      <img class="userPhoto" v-if="message.From !== undefined" :src="$store.getters.getUserById(message.From).PhotoURL">
      <div>
        <div class="userName" v-if="message.From !== undefined">
          {{ $store.getters.getUserById(message.From).VisibleName }}
        </div>
        <div />
      </div>
      <div class="spacer" />
      <div class="closeBtn" @click="closeView">
        <img src="@/assets/images/close2.png">
      </div>
    </div>

    <div class="navBtn prevImgBtn" v-if="selectedImageIndex > 0" @click="selectedImageIndex--">
      <img src="@/assets/images/left_white.png">
    </div>
    <div class="navBtn nextImgBtn" v-if="
      message.MediaURLs !== undefined &&
        selectedImageIndex < message.MediaURLs.length - 1
    " @click="selectedImageIndex++"
    >
      <img src="@/assets/images/right_white.png">
    </div>
    <div class="preview" v-if="message.MediaURLs !== undefined">
      <img :src="image">
    </div>

    <div class="thumbsRow">
      <div style="position:relative" v-for="(imageUrl, index) in imageURLs" :key="index + 'PRTU' + imageUrl">
        <img class="thumbImage" :class="{ selectedThumb: selectedImageIndex === index }" :src="imageUrl" @click="selectThumb(index)">
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventbus.js'
export default {
  props: {
    clickedMessage: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      message: '',
      selectedImageIndex: 0,
      activePreviewSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg=='
    }
  },
  computed: {
    cssProps () {
      return {
        '--topBarColor': this.$config.theme.default.previewPage.topBarColor,
        '--dimBackgroundColor': this.$config.theme.default.previewPage.backgroundColor
      }
    },
    image () {
      if (this.message.mv <= 1) {
        return this.message.MediaURLs[this.selectedImageIndex]
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key.split('').reverse().join('')
        let encryptedBody = this.ewk(this.message.MediaURLs[this.selectedImageIndex], key, iv)
        return process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + this.message.MediaURLs[this.selectedImageIndex] + '&s=' + encodeURIComponent(encryptedBody)
      }
    },
    imageURLs () {
      let urls = []
      if (this.message.MediaURLs !== undefined) {
        for (const image of this.message.MediaURLs) {
          if (this.message.mv <= 1) {
            urls.push(image)
          } else {
            let key = '6a61e395-b49a-4468-bee0-27644e95308f'
            var iv = key.split('').reverse().join('')
            let encryptedBody = this.ewk(image, key, iv)
            urls.push(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + image + '&s=' + encodeURIComponent(encryptedBody))
          }
        }
      }

      return urls
    }
  },
  methods: {
    imageURLV2 (image) {

    },
    closeView () {
      this.$store.state.conversation.activeConversation.preview.imageGalleryView.isVisible = false
    },

    selectThumb (index) {
      this.selectedImageIndex = index
    }
  },

  created () {
    var vm = this
    EventBus.$on('imageGalleryViewOpenedWithMessage', function (data) {
      vm.message = data
    })
  }
}

</script>

<style scoped>
  .imageGalleryViewMain {
    width: 100%;
    height: calc(100% - 00px);
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: var(--dimBackgroundColor);
    z-index: 900000;
    display: flex;
    flex-direction: column;
  }

  .topBar {
    background-color: var(--topBarColor);
    padding: 10px;
    color: white;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
    height: 50px;
  }

  .closeBtn,
  .closeBtn>img {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .closeBtn {
    margin-right: 10px;
  }

  .spacer {
    flex-grow: 1;
  }

  .userPhoto {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    object-fit: cover;
    margin-right: 10px;
  }

  .userName {
    font-weight: 700;
  }

  .preview {
    flex-grow: 1;
    display: flex;
    align-items: stretch;
    padding: 50px;
    justify-content: center;
  }

  .preview>img {
    object-fit: contain;
    max-width: 1600px;
    max-height: calc(100vh - 300px);
  }

  .thumbsRow {
    min-height: 100px;
    background-color: #d1d1d1;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-shrink: 0;
    overflow-x: scroll;
  }

  .thumbsRow::-webkit-scrollbar {
    height: 3px;
  }

  .thumbsRow::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }

  .thumbImage {
    width: 100px;
    height: 100px;
    margin: 10px;
    margin-left: 0px;
    border: 0px solid white;
    transition: all 0.3s ease;
    object-fit: cover;
    cursor: pointer;
  }

  .selectedThumb {
    border: 4px solid white;
    width: 92px;
    height: 92px;
  }

  .navBtn {
    background-color: rgba(0, 0, 0, 0.3);
    width: 50px;
    height: 50px;
    top: calc(50% - 25px);

    position: absolute;
    border-radius: 10px;
    border: 1px solid black;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .prevImgBtn {
    left: 10px;
  }

  .nextImgBtn {
    right: 10px;
  }

  .navBtn>img {
    width: 30px;
    height: 30px;
  }

</style>
